<template>
  <div
    class="file--attachment d-flex flex-column"
    :style="{
      border: `${Outlined ? '3' : '0'}px dashed ${
        fileOptions[current].borderColor
      }`,
      background: Outlined ? 'rgb(227 242 253 / 45%)' : '',
    }"
  >
    <div class="align-self-center">
      <div
        v-if="uploadedFile.name === undefined && !showFile"
        class="font-weight-bold d-flex flex-column"
      >
        <div
          v-ripple="{ center: true }"
          class="file--avatar--outline align-self-center"
        >
          <!-- uploader -->
          <v-avatar
            :color="`${fileOptions[current].color} lighten-3`"
            :size="AvatarSize"
            class="file--avatar"
            @click="$refs.uploader.click()"
          >
            <v-icon
              :color="`${fileOptions[current].color} darken-4`"
              :size="Math.round((8 / 11) * AvatarSize)"
            >
              {{ Icon }}
            </v-icon>
          </v-avatar>
        </div>
        Add {{ IsImage ? "Profile Picture" : "file attachment" }} ({{ Accept }})
      </div>
      <div v-else class="align-self-center font-weight-bold">
        <v-list
          dense
          v-if="
            !IsImage &&
            (uploadedFile.name !== undefined || base64File.length !== 0)
          "
          rounded
          :elevation="displayOptions.elevation"
          :min-width="displayOptions.width"
        >
          <v-list-item dense>
            <v-icon size="25" class="mr-2">{{ Icon }}</v-icon>
            <v-list-item-title sty>
              <v-chip
                :color="fileOptions[current].color"
                class="white--text"
                label
                :style="{ minWidth: displayOptions.width }"
              >
                <v-icon class="mx-1"> attach_file </v-icon>
                {{
                  uploadedFile.name === undefined
                    ? FileName + getFileExtension(base64File)
                    : uploadedFile.name
                }}
              </v-chip>
            </v-list-item-title>
            <v-list-item-action
              class="d-flex flex-row justify-end"
              style="min-width: 17%"
            >
              <v-tooltip v-if="displayOptions.isEdit" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    color="blue lighten-4"
                    label
                    v-bind="attrs"
                    v-on="on"
                    class="mx-2"
                    @click="updateFile()"
                  >
                    <v-icon color="blue darken-4">mode_edit</v-icon>
                  </v-chip>
                </template>
                <span>Update File Attachment</span>
              </v-tooltip>
              <v-tooltip v-if="base64File.length !== 0" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    color="orange lighten-4"
                    label
                    v-bind="attrs"
                    v-on="on"
                    @click="downloadFile(base64File, FileName)"
                  >
                    <v-icon color="orange darken-4">cloud_download</v-icon>
                  </v-chip>
                </template>
                <span>Download File Attachment</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <div
          v-if="uploadedFile.size > 5242880"
          class="align-self-center red--text font-weight-bold"
        >
          File is greater than 5mbs
        </div>
      </div>
    </div>
    <div v-if="showFile && IsImage" class="align-self-center">
      <v-avatar size="150" class="align-self-center">
        <v-img
          contain
          :src="
            base64File.length !== 0
              ? `data:${getMimeType(base64File)};base64, ${base64File}`
              : defaultFile
          "
          class="rounded"
        />
      </v-avatar>
    </div>
    <input
      ref="uploader"
      type="file"
      class="d-none"
      :accept="Accept"
      style="visibility: hidden"
      @change="upload()"
    />
  </div>
</template>
<script>
import helpers from "../utils/helpers/helper.js";
import FileMixin from "../mixin/FileMixin";
export default {
  name: "FileUpload",
  mixins: [FileMixin],
  props: {
    Outlined: Boolean,
    Icon: String,
    Accept: {
      default: "application/pdf",
      type: String,
    },
    IsImage: Boolean,
    showFile: {
      default: false,
      type: Boolean,
    },
    defaultFile: {
      default:
        "https://www.icmetl.org/wp-content/uploads/2020/11/user-icon-human-person-sign-vector-10206693.png",
      type: String,
    },
    base64File: {
      default: "",
      type: String,
    },
    AvatarSize: {
      default: 110,
      type: Number,
    },
    FileName: {
      default: "file-download",
      type: String,
    },
    status: {
      default: "default",
      type: String,
    },
    displayOptions: {
      default: () => {
        return {
          elevation: "0",
          width: "60ch",
          isEdit: false,
        };
      },
      type: Object,
    },
  },
  data: function () {
    return {
      uploadedFile: {},
      current: "default",
    };
  },
  computed: {
    fileOptions() {
      return {
        default: {
          borderColor: "#0D47A1",
          color: "blue",
        },
        error: {
          borderColor: "red",
          color: "deep-orange",
        },
        success: {
          borderColor: "green",
          color: "green",
        },
      };
    },
  },
  mounted() {
    Event.$on("clearUpload", () => {
      this.uploadedFile = {};
      this.current = "default";
    });
  },
  watch: {
    status() {
      this.current = this.status;
    },
  },
  methods: {
    upload() {
      const file = this.$refs.uploader.files[0];
      this.uploadedFile = file;
      this.$emit("updateFile", { file });
    },
    getMimeType(base64) {
      return helpers.detectMimeType(base64);
    },
    getFileExtension(base64) {
      return helpers.fileExtension(base64);
    },
    updateFile() {
      this.uploadedFile = {};
      this.current = "default";
      this.$emit("updateFile", { file: this.uploadedFile });
    },
  },
};
</script>
<style>
.file--attachment {
  border-radius: 4px;
  padding: 1% 0 1% 0;
}
.file--avatar {
  cursor: pointer;
}
.file--avatar--outline {
  padding: 7.5px;
  border-radius: 100%;
  background-color: #e8eaf6;
}
</style>
